import uuid from 'node-uuid'
import {
    apiUrl,
    apiOption,
    apiResponse,
    errorResponse,
    headerResponse,
    jsonResponse,
    UnauthorizedError, ForbiddenError, ServerError, NotFoundError
} from '../core/fetchz'
import loading from '../core/redux/loading'
import config from '../config'
import {linkFinder} from '../core/links'
import {sendAssociateUserWithPatrimonyCmd} from '../company/actions'

const NAMESPACE = 'Patrimony'
export const MINOR_CRITERIA_RESETTED = NAMESPACE + '/MinorCriteriaResetted'
export const MINOR_CONTACT_CRITERIA_RESET = NAMESPACE + '/MinorContactCriteriaReset'
export const LINKS_LOADED = NAMESPACE + '/LinksLoaded'
export const PATRIMONY_STREAM_LOADED = NAMESPACE + '/PatrimonyStreamLoaded'
export const PATRIMONY_STREAM_QUERIED = NAMESPACE + '/PatrimonyStreamQueried'
export const PATRIMONY_LOADED = NAMESPACE + '/PatrimonyLoaded'
export const LOT_STREAM_LOADED = NAMESPACE + '/LotStreamLoaded'
export const LOT_LOADED = NAMESPACE + '/LotLoaded'
export const BUILDING_LOADED = NAMESPACE + '/BuildingLoaded'
export const CONTACT_LINKS_LOADED = NAMESPACE + '/ContactLinksLoaded'
export const CONTACT_STREAM_LOADED = NAMESPACE + '/ContactStreamLoaded'
export const CONTACT_STREAM_QUERIED = NAMESPACE + '/ContactStreamQueried'
export const CONTACT_LOADED = NAMESPACE + '/ContactLoaded'
export const MINOR_CONTACT_STREAM_LOADED = NAMESPACE + '/MinorContactStreamLoaded'
export const MINOR_CONTACT_STREAM_QUERIED = NAMESPACE + '/MinorContactStreamQueried'
export const REFERENCE_PATRIMONY_CMD_SENT = NAMESPACE + '/ReferencePatrimonyCmdSent'
export const REFERENCE_LOT_CMD_SENT = NAMESPACE + '/ReferenceLotCmdSent'
export const REFERENCE_BUILDING_CMDS_SENT = NAMESPACE + '/ReferenceBuildingCmdsSent'
export const REFERENCE_PATRIMONY_CONTACT_CMD_SENT = NAMESPACE + '/ReferencePatrimonyContactCmdSent'
export const UPDATE_PATRIMONY_CMD_SENT = NAMESPACE + '/UpdatePatrimonyCmdSent'
export const UPDATE_LOT_CMD_SENT = NAMESPACE + '/UpdateLotCmdSent'
export const UPDATE_LOT_CMD_RESET = NAMESPACE + '/UpdateLotCmdReset'
export const ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_SENT = NAMESPACE + '/AddComplementaryAddressToPatrimonyCmdSent'
export const REMOVE_COMPLEMENTARY_ADDRESS_FROM_PATRIMONY_CMD_SENT = NAMESPACE + '/RemoveComplementaryAddressFromPatrimonyCmdSent'
export const ASSOCIATE_PATRIMONY_IN_AGENCY_CMD_SENT = NAMESPACE + 'AssociatePatrimonyInAgencyCmdSent'
export const DISSOCIATE_PATRIMONY_FROM_AGENCY_CMD_SENT = NAMESPACE + 'DissociatePatrimonyFromAgencyCmdSent'
export const ADD_ADDRESS_TO_LOT_CMD_SENT = NAMESPACE + '/AddAddressToLotCmdSent'
export const REMOVE_ADDRESS_FROM_LOT_CMD_SENT = NAMESPACE + '/RemoveAddressFromLotCmdSent'
export const DELETE_LOT_CMD_SENT = NAMESPACE + '/DeleteLotCmdSent'
export const LINK_PATRIMONY_CONTACT_WITH_CMD_SENT = NAMESPACE + '/LinkPatrimonyContactWithCmdSent'
export const REMOVE_LINK_FROM_PATRIMONY_CONTACT_CMD_SENT = NAMESPACE + '/RemoveLinkFromPatrimonyContactCmdSent'
export const UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_SENT = NAMESPACE + '/UpdatePatrimonyContactIdentityCmdSent'
export const ADD_CONTACT_CMD_SENT = NAMESPACE + './AddContactCmdSent'
export const REMOVE_CONTACT_CMD_SENT = NAMESPACE + './RemoveContactCmdSent'

export const REFERENCE_USER_CMD_SENT = NAMESPACE + '/ReferenceUserCmdSent'
export const LINK_USER_CMD_SENT = NAMESPACE + '/LinkUserCmdSent'
export const UPDATE_USER_CMD_UPDATED = NAMESPACE + '/UpdateUserCmdUpdated'
export const UPDATE_USER_CMD_SENT = NAMESPACE + '/UpdateUserCmdSent'
// form actions
export const CRITERIA_UPDATED = NAMESPACE + '/CriteriaUpdated'
export const MINOR_CRITERIA_UPDATED = NAMESPACE + '/MinorCriteriaUpdated'
export const CONTACT_CRITERIA_UPDATED = NAMESPACE + '/ContactCriteriaUpdated'
export const MINOR_CONTACT_CRITERIA_UPDATED = NAMESPACE + '/MinorContactCriteriaUpdated'
export const REFERENCE_PATRIMONY_CMD_UPDATED = NAMESPACE + '/ReferencePatrimonyCmdUpdated'
export const REFERENCE_LOT_CMD_UPDATED = NAMESPACE + '/ReferenceLotCmdUpdated'
export const REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED = NAMESPACE + '/ReferencePatrimonyContactCmdUpdated'
export const UPDATE_PATRIMONY_CMD_UPDATED = NAMESPACE + '/UpdatePatrimonyCmdUpdated'
export const UPDATE_LOT_CMD_UPDATED = NAMESPACE + '/UpdateLotCmdUpdated'
export const ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_UPDATED = NAMESPACE + '/AddComplementaryAddressToPatrimonyCmdUpdated'
export const ADD_ADDRESS_TO_LOT_CMD_UPDATED = NAMESPACE + '/AddAddressToLotCmdUpdated'
export const LINK_PATRIMONY_CONTACT_WITH_CMD_UPDATED = NAMESPACE + '/LinkPatrimonyContactWithCmdUpdated'
export const UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_UPDATED = NAMESPACE + '/UpdatePatrimonyContactIdentityCmdUpdated'
export const ADD_CONTACT_CMD_UPDATED = NAMESPACE + './AddContactCmdUpdated'



export const DISABLE_USER_CMD_SENT = 'User/DisableUserCmdSent'

export const DEFAULT_QUERY = {
    range: {offset: 0, limit: 19}
}

export const DEFAULT_PATRIMONY_QUERY = {
    ...DEFAULT_QUERY,
    fullText: null,
    agencyUids: null,
    companyUid: null,
    zipCode: null,
    placeId: null,
    geoLocation: null
}

export const DEFAULT_CONTACT_QUERY = {
    ...DEFAULT_QUERY,
    patrimonyUids: null,
    lotUid: null
}

export function loadLinks() {
    const query = {
        range: {offset: 0, limit: 0}
    }

    return loading(fetch(apiUrl(config.api.url + '/patrimonies', query), apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: LINKS_LOADED,
            _links: json._links
        }
    }), LINKS_LOADED)
}

export function queryPatrimonyStream(patrimonyQuery) {
    return loadPatrimonyStream(patrimonyQuery, PATRIMONY_STREAM_QUERIED)
}

export function loadPatrimonyStream(patrimonyQuery, action) {
    return loading((state) => {
        const {query} = state.patrimony

        patrimonyQuery = {
            ...DEFAULT_PATRIMONY_QUERY,
            ...query,
            ...patrimonyQuery
        }

        return fetch(apiUrl(config.api.url + '/patrimonies', patrimonyQuery), apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: action || PATRIMONY_STREAM_LOADED,
                range: headers.contentRange,
                stream: json.result,
                aggregations: json.aggregations,
                _links: json._links,
                query: patrimonyQuery
            }
        })
    }, action || PATRIMONY_STREAM_LOADED)
}

export function loadPatrimony(id) {
    return loading((state) => {
        const {patrimony} = state.patrimony
        const _appLinks = state.app._links
        id = id || (patrimony && patrimony.uid)

        const buildingsQuery = {
            range: {offset: 0, limit: 0},
        }

        const lotsQuery = {
            range: {offset: 0, limit: 0},
            patrimonyUid: id
        }

        const contactsQuery = {
            range: {offset: 0, limit: 0},
            patrimonyUids: id
        }

        const patrimonyPromise = fetch(config.api.url + '/patrimonies/' + id, apiOption()).then(apiResponse)
        const buildingsPromise = fetch(apiUrl(config.api.url + '/patrimonies/' + id + '/buildings', buildingsQuery), apiOption()).then(apiResponse)
        const lotsPromise = fetch(apiUrl(config.api.url + '/lots', lotsQuery), apiOption()).then(apiResponse)
        const contactsPromise = _appLinks.find(linkFinder('patrimonycontacts')) && fetch(apiUrl(config.api.url + '/patrimonycontacts', contactsQuery), apiOption()).then(apiResponse)

        return Promise.all([patrimonyPromise, buildingsPromise, lotsPromise, contactsPromise]).then(([patrimonyResponse, buildingsResponse, lotsResponse, contactsResponse]) => {
            return {
                type: PATRIMONY_LOADED,
                patrimony: patrimonyResponse.json,
                patrimonyBuildings: {
                    count: buildingsResponse.headers.contentRange.count,
                    _links: buildingsResponse.json._links
                },
                patrimonyLots: {
                    count: lotsResponse.headers.contentRange.count,
                    _links: lotsResponse.json._links
                },
                patrimonyContacts: contactsResponse && {
                    count: contactsResponse.headers && contactsResponse.headers.contentRange ? contactsResponse.headers.contentRange.count : 0,
                    _links: contactsResponse.json && contactsResponse.json._links ? contactsResponse.json._links : []
                } || {}
            }
        })
    }, PATRIMONY_LOADED)
}

export function loadLotAndBuildingStream(patrimonyId) {
    return loading((state) => {
        const {patrimony} = state.patrimony
        patrimonyId = patrimonyId || (patrimony && patrimony.uid)

        const lotsQuery = {
            patrimonyUid: patrimonyId
        }

        const lotsPromise = fetch(apiUrl(config.api.url + '/lots', lotsQuery), apiOption()).then(apiResponse)
        const buildingsPromise = fetch(config.api.url + '/patrimonies/' + patrimonyId + '/buildings', apiOption()).then(apiResponse)

        return Promise.all([lotsPromise, buildingsPromise]).then(([lotsResponse, buildingsResponse]) => {
            return {
                type: LOT_STREAM_LOADED,
                lot: {
                    stream: lotsResponse.json.result
                },
                building: {
                    stream: buildingsResponse.json.result
                }
            }
        })
    }, LOT_STREAM_LOADED)
}

export function loadLotStream(patrimonyId, buildingId) {
    return loading((state) => {
        const {building} = state.patrimony.building
        patrimonyId = patrimonyId || (building && building.patrimony.uid)
        buildingId = buildingId || (building && building.uid)

        const query = {
            patrimonyUid: patrimonyId,
            buildingUids: buildingId
        }

        return fetch(apiUrl(config.api.url + '/lots', query), apiOption())
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: LOT_STREAM_LOADED,
                lot: {
                    stream: json.result
                },
                building: {
                    stream: []
                }
            }
        })
    }, LOT_STREAM_LOADED)
}

export function loadLot(id) {
    return loading((state) => {
        const {lot} = state.patrimony.lot
        id = id || (lot && lot.uid)

        const contactsQuery = {
            range: {offset: 0, limit: 0},
            lotUid: id
        }

        const lotPromise = fetch(config.api.url + '/lots/' + id, apiOption()).then(apiResponse)
        const contactsPromise = fetch(apiUrl(config.api.url + '/patrimonycontacts', contactsQuery), apiOption()).then(apiResponse)

        return Promise.all([lotPromise, contactsPromise]).then(([lotResponse, contactsResponse]) => {
            return {
                type: LOT_LOADED,
                lot: lotResponse.json,
                lotContacts: {
                    count: contactsResponse.headers.contentRange.count,
                    _links: contactsResponse.json._links
                }
            }
        })
    }, LOT_LOADED)
}

export function loadBuilding(patrimonyId, buildingId) {
    return loading((state) => {
        const {patrimony} = state.patrimony
        const {building} = state.patrimony.building
        patrimonyId = patrimonyId || (patrimony && patrimony.uid)
        buildingId = buildingId || (building && building.uid)

        const lotsQuery = {
            range: {offset: 0, limit: 0},
            patrimonyUid: patrimonyId,
            buildingUids: buildingId
        }

        const buildingPromise = fetch(config.api.url + '/patrimonies/' + patrimonyId + '/buildings/' + buildingId, apiOption()).then(apiResponse)
        const lotsPromise = fetch(apiUrl(config.api.url + '/lots', lotsQuery), apiOption()).then(apiResponse)

        return Promise.all([buildingPromise, lotsPromise]).then(([buildingResponse, lotsResponse]) => {
            return {
                type: BUILDING_LOADED,
                building: buildingResponse.json,
                buildingLots: {
                    count: lotsResponse.headers.contentRange.count,
                    _links: lotsResponse.json._links
                }
            }
        })
    }, BUILDING_LOADED)
}

export function loadContactLinks() {
    const query = {
        range: {offset: 0, limit: 0}
    }

    return loading(fetch(apiUrl(config.api.url + '/patrimonycontacts', query), apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: CONTACT_LINKS_LOADED,
            _links: json._links
        }
    }), CONTACT_LINKS_LOADED)
}

export function queryContactStream(contactQuery) {
    return loadContactStream(contactQuery, CONTACT_STREAM_QUERIED)
}

export function loadContactStream(contactQuery, action) {
    return loading((state) => {
        const {query} = state.patrimony.contact

        contactQuery = {
            ...DEFAULT_CONTACT_QUERY,
            ...query,
            ...contactQuery
        }

        return fetch(apiUrl(config.api.url + '/patrimonycontacts', contactQuery), apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: action || CONTACT_STREAM_LOADED,
                stream: json.result,
                range: headers.contentRange,
                _links: json._links,
                query: contactQuery
            }
        })
    }, action || CONTACT_STREAM_LOADED)
}

export function queryMinorContactStream(contactQuery) {
    return loadMinorContactStream(contactQuery, MINOR_CONTACT_STREAM_QUERIED)
}

export function loadMinorContactStream(contactQuery, action) {
    return loading((state) => {
        const {minorQuery} = state.patrimony.contact

        contactQuery = {
            ...DEFAULT_CONTACT_QUERY,
            ...minorQuery,
            ...contactQuery
        }

        return fetch(apiUrl(config.api.url + '/patrimonycontacts', contactQuery), apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: action || MINOR_CONTACT_STREAM_LOADED,
                stream: json.result,
                range: headers.contentRange,
                query: contactQuery
            }
        })
    }, action || MINOR_CONTACT_STREAM_LOADED)
}

export function loadContact(id) {
    return loading((state) => {
        const {contact} = state.patrimony.contact
        id = id || (contact && contact.uid)

        return fetch(config.api.url + '/patrimonycontacts/' + id, apiOption())
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: CONTACT_LOADED,
                contact: json
            }
        })
    }, CONTACT_LOADED)
}

export function sendReferencePatrimonyCmd() {
    return loading((state) => {
        const {referencePatrimonyCmd} = state.patrimony
        
        const option = {
            body: {
                processUid: uuid.v4(),
                commandType: 'ReferencePatrimony',
                ...referencePatrimonyCmd
            }
        }

        return fetch(config.api.event.url + '/patrimonies', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REFERENCE_PATRIMONY_CMD_SENT
            }
        })
    }, REFERENCE_PATRIMONY_CMD_SENT)
}

export function sendReferenceBuildingCmds(addresses) {
    return loading((state) => {
        const {patrimony} = state.patrimony

        const promises = addresses.map((address) => {
            if (address.building && address.building.label && !address.building.uid) {
                const option = {
                    method: 'PATCH',
                    body: {
                        processUid: uuid.v4(),
                        commandType: 'ReferenceBuilding',
                        label: address.building.label
                    }
                }

                return fetch(config.api.event.url + '/patrimonies/' + patrimony.uid, apiOption(option))
                .then((response) => apiResponse(response, {status: [400]}))
                .then(({response, json}) => {
                    var buildingId
                    if (response.status == 200) {
                        buildingId = json.events.find((e) => e.eventType == 'BuildingReferenced').buildingUid
                    } else {
                        buildingId = json.buildingUid
                    }
                    return {...address, building: {...address.building, uid: buildingId}}
                })
            } else {
                return address
            }
        })

        return Promise.all(promises).then((addresses) => {
            return {
                type: REFERENCE_BUILDING_CMDS_SENT,
                addresses: addresses
            }
        })
    }, REFERENCE_BUILDING_CMDS_SENT)
}

export function sendReferenceLotCmd() {
    return loading((state) => {
        const {referenceLotCmd, patrimony} = state.patrimony

        // API expects a building UID 
        const addresses = referenceLotCmd.addresses.map((address) => {
            if (address.building) {
                return {...address, building: address.building.uid}
            } else {
                return address
            }
        })

        const option = {
            body: {
                processUid: uuid.v4(),
                commandType: 'ReferenceLot',
                patrimonyUid: patrimony.uid,
                ...referenceLotCmd,
                addresses
            }
        }

        return fetch(config.api.event.url + '/lots', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REFERENCE_LOT_CMD_SENT
            }
        })
    }, REFERENCE_LOT_CMD_SENT)
}

export function sendReferencePatrimonyContactCmd() {
    return loading((state) => {
        const {referencePatrimonyContactCmd} = state.patrimony
        const {namez, linkedWithEntities, linkedWithPatrimonyAsHomeOwnerAssociation, ...cmd} = referencePatrimonyContactCmd
        
        const option = {
            body: {
                processUid: uuid.v4(),
                name: {
                    ...namez,
                    nameType: 'CivilName'
                },
                linkedWithEntities: [linkedWithEntities, linkedWithPatrimonyAsHomeOwnerAssociation].filter((v) => v),
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/patrimonycontacts', apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            const {events} = json
            return {
                type: REFERENCE_PATRIMONY_CONTACT_CMD_SENT,
                contactUid: events.find(e => e.eventType === 'PatrimonyContactReferenced').aggregateUid,
                name: {
                    ...namez,
                    nameType: 'CivilName'
                },
            }
        })
    }, REFERENCE_PATRIMONY_CONTACT_CMD_SENT)
}

export function sendUpdatePatrimonyCmd() {
    return loading((state) => {
        const {updatePatrimonyCmd, patrimony} = state.patrimony
        const patrimonyId = patrimony.uid
        
        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'UpdatePatrimony',
                comment: 'Reference or Label Updated',
                ...updatePatrimonyCmd
            }
        }

        return fetch(config.api.event.url + '/patrimonies/' + patrimonyId, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_PATRIMONY_CMD_SENT
            }
        })
    }, UPDATE_PATRIMONY_CMD_SENT)
}

export function sendUpdateLotCmd() {
    return loading((state) => {
        const {updateLotCmd} = state.patrimony
        const {lot} = state.patrimony.lot
        const lotId = lot.uid
        const {lotNumber, ref, usage} = updateLotCmd

        const option = (cmdName, cmd) => {
            return {
                method: 'PATCH',
                body: {
                    processUid: uuid.v4(),
                    commandType: cmdName,
                    ...cmd
                }
            }
        }

        return Promise.all([
            lotNumber && fetch(config.api.event.url + '/lots/' + lotId, apiOption(option('UpdateLotNumber', {lotNumber}))).then(errorResponse),
            ref && fetch(config.api.event.url + '/lots/' + lotId, apiOption(option('UpdateLotReference', {ref}))).then(errorResponse),
            usage && fetch(config.api.event.url + '/lots/' + lotId, apiOption(option('UpdateLotUsage', {usage}))).then(errorResponse)
        ]).then(() => {
            return {
                type: UPDATE_LOT_CMD_SENT
            }
        })
    }, UPDATE_LOT_CMD_SENT)
}

export function sendAddComplementaryAddressToPatrimonyCmd() {
    return loading((state) => {
        const {addComplementaryAddressToPatrimonyCmd, patrimony} = state.patrimony

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'AddComplementaryAddressToPatrimony',
                ...addComplementaryAddressToPatrimonyCmd
            }
        }

        return fetch(config.api.event.url + '/patrimonies/' + patrimony.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_SENT
            }
        })
    }, ADD_COMPLEMENTARY_ADDRESS_TO_PATRIMONY_CMD_SENT)
}

export function sendRemoveComplementaryAddressFromPatrimonyCmd(addressId) {
    return loading((state) => {
        const {patrimony} = state.patrimony
        
        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'RemoveComplementaryAddressFromPatrimony',
                addressUid: addressId
            }
        }

        return fetch(config.api.event.url + '/patrimonies/' + patrimony.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_COMPLEMENTARY_ADDRESS_FROM_PATRIMONY_CMD_SENT
            }
        })
    }, REMOVE_COMPLEMENTARY_ADDRESS_FROM_PATRIMONY_CMD_SENT)
}

export function sendAssociatePatrimonyInAgencyCmd(agencyId) {
    return loading((state) => {
        const {patrimony} = state.patrimony

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'AssociatePatrimonyInAgency',
                agencyUid: agencyId
            }
        }

        return fetch(config.api.event.url + '/patrimonies/' + patrimony.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ASSOCIATE_PATRIMONY_IN_AGENCY_CMD_SENT
            }
        })
    }, ASSOCIATE_PATRIMONY_IN_AGENCY_CMD_SENT)
}

export function sendDissociatePatrimonyFromAgencyCmd(agencyId) {
    return loading((state) => {
        const {patrimony} = state.patrimony
        
        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'DissociatePatrimonyFromAgency',
                agencyUid: agencyId
            }
        }

        return fetch(config.api.event.url + '/patrimonies/' + patrimony.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DISSOCIATE_PATRIMONY_FROM_AGENCY_CMD_SENT
            }
        })
    }, DISSOCIATE_PATRIMONY_FROM_AGENCY_CMD_SENT)
}

export function sendAddAddressToLotCmd() {
    return loading((state) => {
        const {addAddressToLotCmd} = state.patrimony
        const {lot} = state.patrimony.lot
        const {address, ...cmd} = addAddressToLotCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'AddAddressToLot',
                address: address.building && {...address, building: address.building.uid} || address,
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/lots/' + lot.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ADD_ADDRESS_TO_LOT_CMD_SENT
            }
        })
    }, ADD_ADDRESS_TO_LOT_CMD_SENT)
}

export function sendRemoveAddressFromLotCmd(addressId) {
    return loading((state) => {
        const {lot} = state.patrimony.lot
        
        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'RemoveAddressFromLot',
                addressUid: addressId
            }
        }

        return fetch(config.api.event.url + '/lots/' + lot.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_ADDRESS_FROM_LOT_CMD_SENT
            }
        })
    }, REMOVE_ADDRESS_FROM_LOT_CMD_SENT)
}

export function sendDeleteLotCmd(lotId) {
    const option = {
        method: 'PATCH',
        body: {
            processUid: uuid.v4(),
            commandType: 'DeleteLot'
        }
    }

    return loading(fetch(config.api.event.url + '/lots/' + lotId, apiOption(option))
    .then(errorResponse)
    .then(() => {
        return {
            type: DELETE_LOT_CMD_SENT
        }
    }), DELETE_LOT_CMD_SENT)
}

export function sendLinkPatrimonyContactWithCmd(contactId) {
    return loading((state) => {
        const {linkPatrimonyContactWithCmd} = state.patrimony

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'LinkPatrimonyContactWith',
                ...linkPatrimonyContactWithCmd
            }
        }

        return fetch(config.api.event.url + '/patrimonycontacts/' + contactId, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: LINK_PATRIMONY_CONTACT_WITH_CMD_SENT
            }
        })
    }, LINK_PATRIMONY_CONTACT_WITH_CMD_SENT)
}

export function sendRemoveLinkFromPatrimonyContactCmd(linkedWith) {
    return loading((state) => {
        const {contact} = state.patrimony.contact

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'RemoveLinkFromPatrimonyContact',
                linkedWith: toLinkedWithCmd(linkedWith)
            }
        }

        return fetch(config.api.event.url + '/patrimonycontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_LINK_FROM_PATRIMONY_CONTACT_CMD_SENT
            }
        })
    }, REMOVE_LINK_FROM_PATRIMONY_CONTACT_CMD_SENT)
}

export function sendUpdatePatrimonyContactIdentityCmd() {
    return loading((state) => {
        const {updatePatrimonyContactIdentityCmd} = state.patrimony
        const {contact} = state.patrimony.contact
        const {namez, ...cmd} = updatePatrimonyContactIdentityCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'UpdatePatrimonyContactIdentity',
                name: {
                    ...namez,
                    nameType: 'CivilName'
                },
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/patrimonycontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_SENT
            }
        })
    }, UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_SENT)
}

export function sendAddContactCmd() {
    return loading((state) => {
        const {addContactCmd} = state.patrimony
        const {contact} = state.patrimony.contact

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'AddContact',
                ...addContactCmd
            }
        }

        return fetch(config.api.event.url + '/patrimonycontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ADD_CONTACT_CMD_SENT
            }
        })
    }, ADD_CONTACT_CMD_SENT)
}

export function sendRemoveContactCmd(medium) {
    return loading((state) => {
        const {contact} = state.patrimony.contact

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                contact: medium,
                commandType: 'RemoveContact'
            }
        }

        return fetch(config.api.event.url + '/patrimonycontacts/' + contact.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_CONTACT_CMD_SENT
            }
        })
    }, REMOVE_CONTACT_CMD_SENT)
}

export function updateReferenceLotCmd(cmd) {
    return {
        type: REFERENCE_LOT_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateAddAddressToLotCmd(cmd) {
    return {
        type: ADD_ADDRESS_TO_LOT_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateUpdateLotCmd(cmd) {
    return {
        type: UPDATE_LOT_CMD_UPDATED,
        cmd: cmd
    }
}

export function resetUpdateLotCmd() {
    return {
        type: UPDATE_LOT_CMD_RESET
    }
}

export function updateReferencePatrimonyContactCmd(cmd) {
    return {
        type: REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateLinkPatrimonyContactWithCmd(cmd) {
    return {
        type: LINK_PATRIMONY_CONTACT_WITH_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateUpdatePatrimonyContactIdentityCmd(cmd) {
    return {
        type: UPDATE_PATRIMONY_CONTACT_IDENTITY_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateMinorCriteria(minorCriteria) {
    return {
        type: MINOR_CRITERIA_UPDATED,
        minorCriteria: minorCriteria
    }
}

export function resetMinorCriteria() {
    return {
        type: MINOR_CRITERIA_RESETTED
    }
}

export function updateMinorContactCriteria(minorCriteria) {
    return {
        type: MINOR_CONTACT_CRITERIA_UPDATED,
        minorCriteria: minorCriteria
    }
}

export function resetMinorContactCriteria(minorCriteria = null) {
    return {
        type: MINOR_CONTACT_CRITERIA_RESET,
        minorCriteria: minorCriteria
    }
}

function toLinkedWithCmd(linkedWith) {
    const {patrimony, lot, ...linkedWithCmd} = linkedWith

    return {
        ...linkedWithCmd,
        patrimonyUid: patrimony && patrimony.uid,
        lotUid: lot && lot.uid
    }
}

/*export const getPatrimonyUserState = (contact) => {
    return contact.patrimonyUserState.stateType
}*/

export const getPatrimonyUserState = (contact) => {
    if(contact._links.find(linkFinder(['CreatePatrimonyUser', 'LinkPatrimonyContactToUser'])))
        return 'NoAccount'
    else if(contact._links.find(linkFinder(['DisableUser'])))
        return 'ActiveAccount'
    else if (contact._links.find(linkFinder(['UpdateLogin'])))
        return 'NotActiveAccount'
    else return contact.patrimonyUserState.stateType
}

const getCommandType = (contact) => {
    return ({
        NoAccount: 'ReferencePatrimonyUser',
        NotActiveAccount: 'UpdateLogin',
        ActiveAccount: 'ActiveUser',
    })[getPatrimonyUserState(contact)]
}

const toName = (name) => {
    const {firstName, lastName, value} = name
    return name.nameType === 'CivilName' ? {firstName, lastName} : { lastName : value}
}

const toUpdateUserCmdUpdated = (contact) => {
    return {
        login: getLogin(contact),
        ...toName(contact.name),
        phone : getPhone(contact),
        contactUid: contact.uid,
    }
}
const getContactInfo = (contactInfoType, map) => (contact) => {
    const contactInfo = contact.contacts.filter(c => c.contactInfoType === contactInfoType)[0]
    return contactInfo ? map(contactInfo) : null
}

export const getPhone = getContactInfo('Phone', (c => c.phone))
export const getLogin = (contact) => {
    if (contact.patrimonyUserState.login) {
        return contact.patrimonyUserState.login
    }
    return getContactInfo('Mail', (c => c.mail))(contact)
}

export function resetReferenceUserCmd() {
    return {
        type: UPDATE_USER_CMD_UPDATED
    }
}

export function updateReferenceUserCmd(show, patrimonyContact) {
    return {
        type: UPDATE_USER_CMD_UPDATED,
        cmd : show ? {
            ...toUpdateUserCmdUpdated(patrimonyContact),
            commandType: getCommandType(patrimonyContact)
        } : null
    }
}

export function sendReferenceUserCmd(login) {
    return loading((state) => {
        const {updateUserCmd, patrimony} = state.patrimony
        const {uid: patrimonyUid} = patrimony
        const {login: loginCmd} = updateUserCmd

        const option = {
            body: {
                processUid: uuid.v4(),
                ...updateUserCmd,
                login : login ? login : loginCmd,
                patrimonies: [patrimonyUid]
            }
        }

        return fetch(config.api.event.url + '/users', apiOption(option))
            .then(r => apiResponse(r,{status : [400]}))
            .then(({response, headers, json}) => {
                const {status} = response
                return {
                    type: REFERENCE_USER_CMD_SENT,
                    userUid: json.events ? json.events.find(e => e.eventType === 'PatrimonyUserReferenced').aggregateUid : json.uid,
                    errorType: status === 400 ? json.errorType : null,
                    status
                }
            })
    }, REFERENCE_USER_CMD_SENT)

}

export function sendLinkPatrimonyContactWithUser(patrimonyUid, contactUid) {
    return loading((state) => {
        const {updateUserCmd} = state.patrimony
        const {userUid, login, contactUid: contactUidCommand} = updateUserCmd

        contactUid = contactUid ? contactUid : contactUidCommand

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                userUid,
                commandType: 'LinkPatrimonyContactWithUser'
            }
        }

        return Promise.all([fetch(config.api.event.url + '/patrimonycontacts/' + contactUid, apiOption(option))
            .then(errorResponse), sendAssociateUserWithPatrimonyCmd(userUid, patrimonyUid)])
            .then(() => {
                return {
                    type: LINK_USER_CMD_SENT,
                    status,
                    contactUid,
                    userUid,
                    login,
                }
            })
    }, LINK_USER_CMD_SENT)
}


export function sendUpdateLoginCmd(uid, login) {
    const option = {
        method: 'PATCH',
        body: {
            processUid: uuid.v4(),
            commandType: 'UpdateLogin',
            login,
        },
    }

    return fetch(config.api.event.url + '/users/' + uid, apiOption(option))
        .then(errorResponse)
        .then(() =>({type: UPDATE_USER_CMD_SENT}))
}

export function sendShouldCreateUser(shouldCreateUser) {
    return {
        type: REFERENCE_PATRIMONY_CONTACT_CMD_UPDATED,
        cmd: {shouldCreateUser}
    }
}


// WEBPACK FOOTER //
// ./lib/patrimony/actions.js